import { Dialog, Button, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RouteInformation } from '../../shared/constants/RouteInformation';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../redux-types';
import DOMPurify from 'dompurify';
import * as UserActions from '../Authorization/userSlice';
import { getUserBroadcastPopup } from '../../shared/requests/broadcastPopupRequests';

const BroadcastPopupDialog: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userBroadcastPopup = useSelector((state: StoreState) => state.user.broadcastPopup);

  const [open, setOpen] = useState(true);
  const [isHandling, setIsHandling] = useState(false);

  const handleOK = async () => {
    if (isHandling) {
      return;
    }
    setIsHandling(true);
    try {
      const nextPopup = await getUserBroadcastPopup();
      if (!nextPopup.seen) {
        dispatch(UserActions.setUserBroadcastPopup(nextPopup));
        setOpen(true);
        return;
      }
    } finally {
      setIsHandling(false);
    }

    dispatch(
      UserActions.setUserBroadcastPopup({
        ...userBroadcastPopup,
        seen: true,
      })
    );
    navigate(RouteInformation.serviceLog.path, { replace: true });
    setOpen(false);
  };

  const title = userBroadcastPopup.popupType === 'new-users' ? 'Welcome' : 'Announcement';

  return (
    <Dialog open={open} fullWidth maxWidth="md" data-cy="broadcast-popup-dialog">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(userBroadcastPopup.content) }} />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => handleOK()}
          data-cy="broadcast-popup-dialog-ok-btn"
          disabled={isHandling}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BroadcastPopupDialog;
